module.exports = __webpack_public_path__ + "static/media/Vaporeon_gaussian2.d5c3347b.png";